import { useContext } from 'react';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { LanguageProviderContext } from '@/providers/LanguageProvider';

/**
 * Thin, always-visible bar shown while the device is offline so staff know that
 * changes are being kept on this device and will sync when the connection returns.
 */
export const OfflineBanner = () => {
  const isOnline = useOnlineStatus();
  const { translator } = useContext(LanguageProviderContext);

  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex w-full items-center justify-center gap-2 bg-amber-500 px-3 py-1.5 text-center text-sm font-medium text-amber-950"
    >
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>{translator('Offline.bannerMessage')}</span>
    </div>
  );
};
